import { NavLink } from "react-router-dom";
import { Icon } from "@/components";
import { IconType } from "@/components/Icon/icons";
import "./navItem.scss";

interface NavItemProps {
  to: string;
  iconName: IconType;
  iconSize?: number;
  defaultColor?: string;
  activeColor?: string;
  children: React.ReactNode;
}

const NavItem = ({
  to,
  iconName,
  iconSize = 32,
  defaultColor = "#808080",
  activeColor = "#169FED",
  children,
}: NavItemProps) => {
  return (
    <NavLink
      className={({ isActive }) => `link ${isActive ? "active-link" : ""}`}
      to={to}
    >
      {({ isActive }) => (
        <div className="icon-and-text">
          <Icon
            name={iconName}
            size={iconSize}
            color={isActive ? activeColor : defaultColor}
          />
          <div>{children}</div>
        </div>
      )}
    </NavLink>
  );
};

export default NavItem;
